import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import { CoreButton } from 'src/components/core'
import styles from '../styles'

const UpgradeRedirect = ({ classes }) => {
  const handleUpgradeClick = () => {
    window.location.href = '/upgrade'
  }

  return (
    <div className={classes.upgradeContainer}>
      <Typography variant="h6" className={classes.upgradeTitle}>
        Upgrade Required
      </Typography>
      <Typography className={classes.upgradeDescription}>
        To use white label email features, you need to upgrade your plan.
      </Typography>
      <CoreButton
        variant="contained"
        color="primary"
        onClick={handleUpgradeClick}
        className={classes.upgradeButton}
      >
        Upgrade Now
      </CoreButton>
    </div>
  )
}

export default withStyles(styles)(UpgradeRedirect)
